import React, { useState } from 'react';
import dummyData from '../../utils/dummyData';

const ApiKeyComponent = () => {
  const [copiedIndex, setCopiedIndex] = useState(null);
  const apiData = dummyData["jarvis"];

  const copyToClipboard = (apiKey, index) => {
    navigator.clipboard.writeText(apiKey)
      .then(() => {
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 2000);
      })
      .catch(err => console.error('Failed to copy:', err));
  };

  const styles = {
    container: {
      padding: '19px',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'Google Sans, Roboto, sans-serif',
    },
    card: {
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      backgroundColor: '#fff',
      marginBottom: '30px',
      overflow: 'hidden',
    },
    cardHeader: {
      backgroundColor: '#f1f3f4',
      padding: '24px 32px',
      borderBottom: '1px solid #e0e0e0',
      fontSize: '20px',
      fontWeight: '600',
      color: '#202124',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    cardBody: {
      padding: '32px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '24px'
    },
    label: {
      display: 'block',
      fontSize: '14px',
      fontWeight: '500',
      color: '#5f6368',
      marginBottom: '8px',
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      fontSize: '15px',
      borderRadius: '10px',
      border: '1px solid #dadce0',
      outline: 'none',
      backgroundColor: '#fefefe',
    },
    apiKeyGroup: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #dadce0',
      borderRadius: '10px',
      overflow: 'hidden',
      backgroundColor: '#fefefe',
    },
    apiKeyInput: {
      flex: 1,
      border: 'none',
      padding: '12px 16px',
      fontSize: '15px',
      outline: 'none',
      background: 'transparent',
    },
    copyButton: {
      backgroundColor: 'var(--primary-500)',
      color: '#fff',
      padding: '0 20px',
      fontSize: '14px',
      height: '50px',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    alertBox: {
      backgroundColor: '#fff3cd',
      borderLeft: '4px solid #ffcc00',
      padding: '16px 20px',
      marginBottom: '24px',
      fontSize: '14px',
      borderRadius: '8px',
      color: '#7f5700',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    icon: {
      width: '20px',
      height: '20px',
    },
    required: {
      color: '#d93025',
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.alertBox}>
        <svg style={styles.icon} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#ffcc00">
          <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M5.07 21h13.86c1.1 0 2.07-.9 2.07-2V5c0-1.1-.97-2-2.07-2H5.07C3.97 3 3 3.9 3 5v14c0 1.1.97 2 2.07 2z" />
        </svg>
        Don’t expose your API key in public. Always keep it secret and rotate regularly.
      </div>

      {apiData && apiData.map((apiItem, index) => (
        <div key={index} style={styles.card}>
          <div style={styles.cardHeader}>
            <svg width="20" height="20" fill="none" stroke="#1a73e8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M21 2l-2 2M13 11a5.5 5.5 0 11-7.778 7.778A5.5 5.5 0 0113 11zm0 0L15.5 7.5l3 3L22 7l-3-3-3.5 3.5z" />
            </svg>
            Claude.ai Credentials
          </div>
          <div style={styles.cardBody}>
            <div>
              <label style={styles.label}>API ID <span style={styles.required}>*</span></label>
              <input style={styles.input} type="text" value={apiItem.id} readOnly />
            </div>
            <div>
              <label style={styles.label}>Organization ID <span style={styles.required}>*</span></label>
              <input style={styles.input} type="text" value={apiItem.organizationId} readOnly />
            </div>
            <div>
              <label style={styles.label}>Assistant ID <span style={styles.required}>*</span></label>
              <input style={styles.input} type="text" value={apiItem.assistantId} readOnly />
            </div>
            <div>
              <label style={styles.label}>API Key <span style={styles.required}>*</span></label>
              <div style={styles.apiKeyGroup}>
                <input
                  style={styles.apiKeyInput}
                  type="password"
                  value={apiItem.api_key}
                  readOnly
                />
                <button
                  style={styles.copyButton}
                  onClick={() => copyToClipboard(apiItem.api_key, index)}
                >
                  {copiedIndex === index ? "Copied!" : "Copy"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ApiKeyComponent;
